import type { ZodError } from 'zod';
import type { ClientConfig } from './ClientConfig';
import type { OptionsStrict } from './types';

export function validateData(
  path: string,
  options: OptionsStrict,
  config: ClientConfig
) {
  return (d: any) => {
    if (!options.schema) {
      return d;
    }

    const data = Array.isArray(d) ? [...d] : [d];
    let error: ZodError | undefined, datum: any;

    while (data.length > 0 && error === undefined) {
      datum = data.shift();
      const parseResult = options.schema.safeParse(datum);
      if (!parseResult.success) {
        error = parseResult.error;
      }
    }

    if (error) {
      config.onValidationError?.(error, { path, data: datum });

      if (config.logLevel === 'debug') {
        console.warn('Incorrect data', {
          error: {
            ...error,
            toString() {
              return 'Error';
            },
          },
          path,
          datum,
        });
      }
    }

    return d;
  };
}
